export default "__VITE_ASSET__CNGEt1YL__"